export default "__VITE_ASSET__c2b1490e__"